// import jQuery from 'jquery';
import * as amplitude from '@amplitude/analytics-browser';
import { i18n } from "config/i18n";
import Analytics from '@services/analytics';

if(typeof AMPLITUDE_KEY !== "undefined" && typeof AMPLITUDE_CURRENT_CLIENT_ID !== "undefined"){
    amplitude.init(AMPLITUDE_KEY, AMPLITUDE_CURRENT_CLIENT_ID);
}

window.i18n = i18n;
i18n.locale = LOCALE;
window.Analytics = Analytics;
// window.jQuery = jQuery;
// window.$ = jQuery;
window.amplitude = amplitude;

